import "./styles/style.scss";
import "../guest-entry-grid/styles/view.scss";

import Swiper from "swiper/bundle";
import 'swiper/swiper-bundle.css';

const swiper = new Swiper('.wp-block-madden-blocks-guestbook', {
    lazy: {
        loadPrevNext: true,
      },
    // Swiper options
    effect: 'fade',
    loop: true,
    pagination: {
        el: '.guestbook-swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.guestbook-swiper-button-next',
        prevEl: '.guestbook-swiper-button-prev',
    },
});